import React from "react";

const FormItemOptions = ({ item, onOptionChange }) => {
  return (
    <div className="space-y-2 mt-2">
      {item.options.map((option) => (
        <label
          key={option.id}
          className="flex items-center space-x-2 hover:cursor-pointer"
        >
          <input
            type="radio"
            name={`option-${item.id}`}
            value={option.id}
            checked={item.selectedOption?.id === option.id}
            onChange={() => onOptionChange(item.id, option.id)}
            className="form-radio"
          />
          <span
            className={`${
              item.selectedOption?.id === option.id ? "font-bold" : "font-light"
            } text-sm`}
          >
            {option.label}
          </span>
        </label>
      ))}
    </div>
  );
};

export default FormItemOptions;
